import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Dropzone from '../../components/Dropzone/Dropzone';

const Dropzones = () => (
  <React.Fragment>
    <Row className="styles-section" id="drag-drop">
      <Col xs={12}>
        <h3>Dropzones</h3>
      </Col>
      <Col xs={12} sm={6}>
        <form onSubmit={(e) => {
          e.preventDefault();
        }}>
          <Dropzone onChange={(event, state) => {
            console.log(event);
            console.log(state);
          }} />
        </form>
      </Col>

      <Col xs={12} sm={6}>
        <Dropzone selectFiles onChange={(event, state) => {
          console.log(event);
          console.log(state);
        }} />
      </Col>

    </Row>
  </React.Fragment>
);

export default Dropzones;